import { SvgIndexable } from "./Illustration.props";

import { ReactComponent as Adjudication } from "./svg/adjudication.svg";
import { ReactComponent as Buildings } from "./svg/buildings.svg";
import { ReactComponent as ClaimsSearch } from "./svg/claims-search.svg";
import { ReactComponent as ClearingHouse1 } from "./svg/clearinghouse-1.svg";
import { ReactComponent as ClearingHouse2 } from "./svg/clearinghouse-2.svg";
import { ReactComponent as CustomerService } from "./svg/customer-service.svg";
import { ReactComponent as DrugSearch } from "./svg/drug-search.svg";
import { ReactComponent as Formulary } from "./svg/formulary.svg";
import { ReactComponent as Invoice } from "./svg/adjudication.svg";
import { ReactComponent as MagnifyingGlass } from "./svg/magnifying-glass.svg";
import { ReactComponent as MailService } from "./svg/mail-service.svg";
import { ReactComponent as Mailbox } from "./svg/mailbox.svg";
import { ReactComponent as Manufacturer } from "./svg/manufacturer.svg";
import { ReactComponent as MemberDocuments } from "./svg/member-documents.svg";
import { ReactComponent as MemberLookup } from "./svg/member-lookup.svg";
import { ReactComponent as MemberLookup2 } from "./svg/member-lookup-2.svg";
import { ReactComponent as MobileMessage } from "./svg/mobile-message.svg";
import { ReactComponent as Network } from "./svg/network.svg";
import { ReactComponent as Network2 } from "./svg/network-2.svg";
import { ReactComponent as PatientsPills } from "./svg/patients-pills.svg";
import { ReactComponent as Payments } from "./svg/payments.svg";
import { ReactComponent as PharmacySearch } from "./svg/pharmacy-search.svg";
import { ReactComponent as PillBottles } from "./svg/pill-bottles.svg";
import { ReactComponent as PlanManagement } from "./svg/plan-management.svg";
import { ReactComponent as Press } from "./svg/press.svg";
import { ReactComponent as PrintVendor } from "./svg/print-vendor.svg";
import { ReactComponent as RejectsAging } from "./svg/rejects-aging.svg";
import { ReactComponent as RejectsSummary } from "./svg/rejects-summary.svg";
import { ReactComponent as Reporting } from "./svg/reporting.svg";
import { ReactComponent as TestClaimAdjudication } from "./svg/test-claim-adjudication.svg";
import { ReactComponent as Underwriting2 } from "./svg/underwriting-2.svg";
import { ReactComponent as UserPermissions } from "./svg/user-permissions.svg";
import { ReactComponent as VendorData } from "./svg/vendor-data.svg";
import { ReactComponent as VideoPlay } from "./svg/video-play.svg";
import { ReactComponent as ZeroDollars } from "./svg/zero-dollars.svg";
import { ReactComponent as Medical } from "./svg/medical.svg";

const IllustrationNames: SvgIndexable = {
  adjudication: Adjudication,
  buildings: Buildings,
  "claims-search": ClaimsSearch,
  "clearing-house-1": ClearingHouse1,
  "clearing-house-2": ClearingHouse2,
  "customer-service": CustomerService,
  "drug-search": DrugSearch,
  formulary: Formulary,
  invoice: Invoice,
  "magnifying-glass": MagnifyingGlass,
  "mail-service": MailService,
  mailbox: Mailbox,
  manufacturer: Manufacturer,
  "member-documents": MemberDocuments,
  "member-lookup": MemberLookup,
  "member-lookup-2": MemberLookup2,
  "mobile-message": MobileMessage,
  network: Network,
  "network-2": Network2,
  "patients-pills": PatientsPills,
  payments: Payments,
  "pharmacy-search": PharmacySearch,
  "pill-bottles": PillBottles,
  "plan-management": PlanManagement,
  press: Press,
  "print-vendor": PrintVendor,
  "rejects-aging": RejectsAging,
  "rejects-summary": RejectsSummary,
  reporting: Reporting,
  "test-claim-adjudication": TestClaimAdjudication,
  "underwriting-2": Underwriting2,
  "user-permissions": UserPermissions,
  "vendor-data": VendorData,
  "video-play": VideoPlay,
  "zero-dollars": ZeroDollars,
  medical: Medical,
};

export default IllustrationNames;
